import styled from 'styled-components'
import WizrFlexLayout from '../WizrFlexLayout'
import WizrText from '../WizrText'
import WizrDropDown from '../WizrDropDown'
import { Form, DatePicker, Radio, RadioChangeEvent } from 'antd'
import { useEffect, useState } from 'react'
import { useGetIntegrationList, useGetMasterIntegrationList, usePastTicketDataSelector } from '../../redux/selectors/content'
import {
  dispatchCreateScheduler,
  dispatchGetIntegrationForTools,
  dispatchGetIntegrationToolsForTenants,
  dispatchIntegrationList,
  dispatchMasterIntegrationList,
  dispatchListFolders,
  dispatchlistScheduler,
  dispatchUpdateScheduler,
} from '../../redux/actions/content'
import ZendeskIcon from '../../assets/icons/ZendeskIcon'
import WizrButton from '../WizrButton'
import dayjs, { Dayjs } from 'dayjs'
import WizrInput from '../WizrInput'
import WizrToggleButton from '../WizrToggleButton'
import WizrTimePicker from '../WizrTimePicker'
import { convertLocalToUTC, convertTimeToUTC } from '../../utils'
import Freshdesk from '../../assets/icons/FreshdeskIcon'
import Salesforce from '../../assets/icons/Salesforce'
import Slack from '../../assets/icons/Slack'
import JiraIcon from '../../assets/icons/Jira'
import ConfluenceIcon from '../../assets/icons/confluence'
import ServiceNowIcon from '../../assets/icons/ServiceNowIcon'



interface ToggleChangeEvent {
  target: {
    checked: boolean;
  };
}

interface WizrTimePickerProps {
  value: Dayjs | null;
  onChange: (time: Dayjs | null, dateString: string) => void;
  format?: string;
}

const InputContainer = styled(WizrFlexLayout)`
  flex-direction: column;
  align-items: flex-start;
  gap: 5px;
  background-color: #fff;
`
const StyledDropDown = styled(WizrDropDown)`
  height: 50px;
  .ant-select-selector {
    border-radius:16px;
    height: 50px !important;
    background-color: #f2f4f9 !important;
    display: flex !important;
    align-items: center !important;
    .ant-select-selection-placeholder {
      display: flex;
      align-items: center;
    }
    .ant-select-selection-item {
      display: flex !important;
      align-items: center !important;
    }
  }
`

const StyledDatePicker = styled(DatePicker)`
  background-color: #f2f4f9 !important;
  width: 100% !important;
  border-radius:16px;
  height: 50px !important;
`

const StyledTimePicker = styled(WizrTimePicker)`
.ant-picker-input{
  background-color: #f2f4f9 !important;
  width: 500px !important;
  border-radius:16px;
  height: 50px !important;
  }
.ant-picker{
  background-color: #f2f4f9 !important;
  width: 500px !important;
  border-radius:16px;
  height: 50px !important;
  }
`

const StyledButton = styled(WizrButton)`
  height: 40px !important;
  width: 90px !important;
  border-radius: 20px !important;
  border: 1px solid black !important;
`
const StyledTextButton = styled(WizrText)`
  text-decoration: underline !important;
`
const StyledWizrInput = styled(WizrInput)`
  border-radius:16px !important;
`

const StyledWizrTagInput = styled(WizrInput)`
background-color: #f2f4f9;
`
interface IAddSchedule {
  isEdit?: boolean;
  editData?: any;
  onFormSubmission: (params: { [key: string]: any }) => void;
  onCancel: () => void;
}

const AddSchedule = ({
  isEdit = false,
  editData,
  onFormSubmission,
  onCancel,
}: IAddSchedule): JSX.Element => {


  const [form] = Form.useForm()


  const onSchedule = async () => {
    const executionTimeUTC = convertTimeToUTC(data.execution_time);
  const importStartDateUTC = convertLocalToUTC(data.start_date);
  const importEndDateUTC = convertLocalToUTC(data.end_date);
  const executionDateUTC = convertLocalToUTC(data.execution_date);
    // Common payload properties
    const basePayload = {
      folder_id: data?.folder_id,
      folder_name: data?.folder_name,
      tool: data?.tool_name,
      integration_id: data?.integration_id,
      integration_name: data?.integration_display_name,
      email_id: data?.registered_emailid,
      ticket_status: data?.ticket_status,
      execution_time: executionTimeUTC,
    };

    let payload;

    if (!isToggled) {
      // Not a repeat event
      payload = {
        ...basePayload,
        repeat_event: false,
        execution_date: executionDateUTC,
      };
    } else {
      // Repeat event - common properties
      const repeatPayload = {
        ...basePayload,
        repeat_event: true,
        repeat_duration: data?.radio_value,
        scheduler_start_date: importStartDateUTC,
        scheduler_end_date: importEndDateUTC,
      };

      // Add specific properties based on repeat type
      switch (data?.radio_value) {
        case 'daily':
          payload = {
            ...repeatPayload,
            // Add any daily-specific properties here
          };
          break;

        case 'weekly':
          payload = {
            ...repeatPayload,
            execution_day: data?.execution_day, // Day of week
          };
          break;

        case 'monthly':
          payload = {
            ...repeatPayload,
            execution_day: data?.execution_date, // Date of month
          };
          break;

        case 'hourly':
          payload = {
            ...repeatPayload,
            hourly_interval: data?.hourly_interval, // Hourly interval
          };
          break;

        default:
          payload = repeatPayload;
      }
    }
    if (isEdit && editData?.scheduler_id) {
      payload = {
        ...payload,
        scheduler_id: editData?.scheduler_id
      };
    }

    const formattedData = {
      name: data.folder_name,
      tool: data.tool_name,
      integration: data.integration_display_name,
      emailaddress: data.registered_emailid,
      repeated: isToggled ? data.radio_value : 'No',
      date_range: {
        start: data.start_date,
        end: data.end_date
      },
      last_run: data.execution_time
    };

    try {
      if (isEdit) {
        await dispatchUpdateScheduler({
          ...payload,
          scheduler_id: editData.scheduler_id
        });
        // Call the list API after the edit is successful
        await dispatchlistScheduler({ offset: 0, limit: 10 });
        onCancel();
      } else {
        await dispatchCreateScheduler(payload);
        await dispatchlistScheduler({ offset: 0, limit: 10 });
      }
    
      onFormSubmission({ data: formattedData });
      onCancel();
    } catch (error) {
      console.error('Error saving scheduler:', error);
    }
  };

  const [data, setdata] = useState({
    folder_id: '',
    folder_name: '',
    tool_name: '',
    integration_id: '',
    integration_display_name: '',
    registered_emailid: '',
    ticket_status: '',
    tool: '',
    repeat: '',
    radio_value: '',
    repeat_duration: '',
    execution_time: '',
    start_date: '',
    end_date: '',
    execution_date: '',
    execution_day: '',
    hourly_interval: '',
  });

  const [radioValue, setRadioValue] = useState(1);
  const [isToggled, setIsToggled] = useState(false);
  const dateOptions = [
    ...Array.from({ length: 31 }, (_, i) => ({
      label: `${i + 1}`,
      value: i + 1
    })),
    { label: 'Last', value: 'last' }
  ];

  const masterIntegrations = useGetMasterIntegrationList()
  const integrationsForTools = useGetIntegrationList()
  const foldersList = usePastTicketDataSelector()
  useEffect(() => {
    dispatchMasterIntegrationList()
    //dispatchGetIntegrationToolsForTenants()
    dispatchIntegrationList()
    dispatchListFolders('past_tickets')



  }, [])


  useEffect(() => {
    if (isEdit && editData) {

      const repeatDurationToRadioValue: { [key: string]: number } = {
        'daily': 1,
        'weekly': 2,
        'monthly': 3
      };

      setRadioValue(repeatDurationToRadioValue[editData.repeat_duration] || 1);
      setIsToggled(editData.repeat_event || false);

      if (editData.execution_time) {
        setTimeValue(dayjs(editData.execution_time, 'HH:mm:ss'));
      }

    setIsToggled(editData?.repeat_event || false);
    }
  }, [isEdit, editData]);

  useEffect(() => {
    if (isEdit && editData) {
      form.setFieldsValue({
        folder_name: editData?.folder_name,
        tool_name: editData?.tool,
        integration_id: editData?.integration_id,           // Added this
        integration_display_name: editData?.integration_name,
        registered_emailid: editData?.email_id,
        ticket_status: editData?.ticket_status,
        radio_value: editData?.repeat_duration,
        repeat: editData?.repeat_event ? 'yes' : 'no',
        start_date: editData?.import_start_date || editData?.scheduler_start_date || '',
        end_date: editData?.import_end_date || editData?.scheduler_end_date || '',
        execution_date: editData?.execution_date || '',
        execution_day: editData?.execution_week_day || '',
      });

      setdata({
        folder_id: editData?.folder_id || '',
        folder_name: editData?.folder_name || '',
        tool_name: editData?.tool || '',
        integration_id: editData?.integration_id || '',
        integration_display_name: editData?.integration_name || '',
        registered_emailid: editData?.email_id || '',
        ticket_status: editData?.ticket_status || '',
        tool: editData?.tool || '',
        repeat: editData?.repeat_event ? 'yes' : 'no',
        radio_value: editData?.repeat_duration || '',
        repeat_duration: editData?.repeat_duration || '',
        execution_time: editData?.execution_time || '',
        start_date: editData?.import_start_date || editData?.scheduler_start_date || '',
        end_date: editData?.import_end_date || editData?.scheduler_end_date || '',
        execution_date: editData?.execution_date || '',
        execution_day: editData?.execution_week_day || '',
        hourly_interval: editData?.hourly_interval || '',
      });
      const repeatDurationToRadioValue: { [key: string]: number } = {
        'daily': 1,
        'weekly': 2,
        'monthly': 3
      };
      setRadioValue(repeatDurationToRadioValue[editData.repeat_duration] || 1);
      setIsToggled(editData.repeat_event || false);

      if (editData.execution_time) {
        setTimeValue(dayjs(editData.execution_time, 'HH:mm:ss'));
      }
    }
  }, [form, isEdit, editData]);



  const onChangeRadio = (e: RadioChangeEvent) => {
    const selectedValue = e.target.value;
    setRadioValue(selectedValue);
    
    let repeatValue;
    switch (selectedValue) {
      case 1:
        repeatValue = 'daily';
        break;
      case 2:
        repeatValue = 'weekly';
        break;
      case 3:
        repeatValue = 'monthly';
        break;
      case 4:
        repeatValue = 'hourly';
        break;
      default:
        repeatValue = '';
    }
    setdata({ ...data, radio_value: repeatValue });
  };

  const handleToggleChange = (isEnabled: boolean) => {
    setIsToggled(isEnabled);
  
    if (isEnabled) {
      // Default to "daily" when toggled on
      setRadioValue(1);
      setdata({ ...data, radio_value: 'daily' });
    } else {
      // Reset or handle the toggle off state as needed
      setdata({ ...data, radio_value: '' });
    }
  };

  const getIcon = (item:any) =>{
    switch(item?.integration_key){
      case 'zendesk':
        return <ZendeskIcon/>
      case 'freshdesk':
        return <Freshdesk/> 
        case 'salesforce':
        return <Salesforce/> 
        case 'confluence':
        return <ConfluenceIcon/> 
        case 'jira':
        return <JiraIcon/> 
        case 'slack':
        return <Slack/>
        case 'servicenow':
        return <ServiceNowIcon/>
      default:
        return null 
    }
  }

  const dateFormat = 'YYYY-MM-DD HH:mm:ss'
  const defaultTime = '00:00:00'

  const disabledDate = (date: Dayjs): boolean => {
    if (!data?.start_date) return false // Return false if start_date is not available

    const startDate = dayjs(data.start_date, dateFormat).startOf('day')
    return date.isBefore(startDate, 'day')
  }

  const allowedIntegrations = ['salesforce', 'freshdesk', 'servicenow', 'jira', 'zendesk'];
  const dropDownConverter = (value: any[]) => {
    if (!Array.isArray(value)) return [];
  
    return value
      .filter((item: any) => 
        item.integration_key !== 'slack' && 
        item.integration_key !== 'confluence' && 
        allowedIntegrations.includes(item.integration_key) // Filter based on allowed keys
      )
      .map((item: any) => ({
        label: (
          <div style={{ alignItems: 'center', display: 'flex', gap: '10px' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>{getIcon(item)}</div>
            <div style={{ display: 'flex', alignItems: 'center', lineHeight: 'normal' }}>{item.display_name}</div>
          </div>
        ),
        value: item.integration_key || item.tool
      }));
  };

  const dropDownConverterIntegrations = (value: string[]) => {
    const result =
      value?.length > 0 &&
      value?.map((item: any) => ({
        label: item?.display_name,
        value: item.integration_id  // Use integration_id as value
      }));
    return result;
  };

  const dropDownConverterFolders = (value: string[]) => {
    const result =
      value?.length > 0 &&
      value?.map((item: any, key: number) => ({
        label: item?.folder_name,
        value: item.folder_id,
      }))
    return result
  }

  const onToolSelection = (value: any, label: any) => {
    dispatchGetIntegrationForTools(value)

    setdata({ ...data, tool_name: value })
  }

  const onFolderSelection = (value: any, option: any) => {
    setdata({
      ...data,
      folder_id: value,  // Store the folder ID
      folder_name: option?.label // Optionally store the folder name if needed
    });
  }

  const onChangeStartDate = (date: any, dateString: any) => {
    // Replace space with 'T' in the dateString
    const formattedDate = dateString.replace(' ', 'T');
    setdata({ ...data, start_date: formattedDate });
  };
  
  const onChangeEndDate = (date: any, dateString: any) => {
    // Replace space with 'T' in the dateString
    const formattedDate = dateString.replace(' ', 'T');
    setdata({ ...data, end_date: formattedDate });
  };

  const daysOfWeek = [
    { label: 'Monday', value: 'monday' },
    { label: 'Tuesday', value: 'tuesday' },
    { label: 'Wednesday', value: 'wednesday' },
    { label: 'Thursday', value: 'thursday' },
    { label: 'Friday', value: 'friday' },
    { label: 'Saturday', value: 'saturday' },
    { label: 'Sunday', value: 'sunday' }
  ];

  const [timeValue, setTimeValue] = useState<Dayjs | null>(null);

  const handleTimeChange = (time: Dayjs | null, timeString: string) => {
    setTimeValue(time);
    setdata({ ...data, execution_time: timeString });
  };

  const handleDateSelection = (value: string | number) => {
    setdata({ ...data, execution_date: String(value) });
  };

  const handleDaySelection = (value: string) => {
    setdata({ ...data, execution_day: value });
  };




  const TicketStatus = [{
    label: "New",
    value: "new"
  }, {
    label: "Open",
    value: "open"
  }, {
    label: "Pending",
    value: "pending"
  },
  {
    label: "Hold",
    value: "hold"
  },
  {
    label: "Closed",
    value: "closed"
  },
  ]
  const hourlyIntervalOptions = Array.from({ length: 23 }, (_, i) => ({
    label: `${i + 1} hour${i > 0 ? 's' : ''}`,
    value: i + 1,
  }));

  return (
    <WizrFlexLayout justifyContent='space-between' background='white' style={{ gap: '20px', padding: '16px' }}>
      {/* <Form.Item
          name='folder_name'
          rules={[{ required: true, message: ' Enter Folder Name', whitespace: true }]}>
          <WizrFlexLayout background='white' textAlign='left' style={{ gap: '10px' }}>
            <WizrText type='body2' textColor='#707276'>Folder Name</WizrText>

            <StyledWizrTagInput
              placeholder='Enter Folder Name'
              onChange={(value: string) => {
                setdata({ ...data, folder_name: value })
                form.setFieldsValue({ folder_name: value })
              }}
              value={data?.folder_name}
            />
          </WizrFlexLayout>
        </Form.Item> */}


      <InputContainer>
        <WizrText type='body2'>Select Folder</WizrText>
        <StyledDropDown
          value={data?.folder_id}
          options={dropDownConverterFolders(foldersList)}
          onChange={(value: any, option: any) => {
            onFolderSelection(value, option)
          }}
        />
      </InputContainer>





      <InputContainer>
        <WizrText type='body2'>Select Tool</WizrText>
        <StyledDropDown
          value={data?.tool_name}
          options={dropDownConverter(masterIntegrations || [])}  // Removed .data
          onChange={(value: any, label: any) => {
            onToolSelection(value, label);
          }}
        />
      </InputContainer>

      <InputContainer>
        <WizrText type='body2'>Select Integrations</WizrText>
        <StyledDropDown
          value={data?.integration_display_name}  // Use display name for the value
          options={dropDownConverterIntegrations(integrationsForTools)}
          onChange={(value: any, option: any) => {
            setdata({
              ...data,
              integration_id: value,  // Store the ID
              integration_display_name: option.label  // Store the display name
            });
          }}
        />
      </InputContainer>
      {/* <InputContainer>
        <WizrFlexLayout flexDirection='row' background='white' style={{ gap: '20px' }}>
          <InputContainer>
            <WizrText type='body2'>Start Date</WizrText>

            <StyledDatePicker
              onChange={onChangeStartDate}
              showTime={{ defaultValue: dayjs(defaultTime, 'HH:mm:ss') }}
            />
          </InputContainer>
          <InputContainer>
            <WizrText type='body2'>End Date</WizrText>
            <StyledDatePicker onChange={onChangeEndDate} disabledDate={disabledDate} showTime />
          </InputContainer>
        </WizrFlexLayout>
      </InputContainer> */}

      <Form.Item
        style={{ marginBottom: "0px" }}
        name='registered_emailid'
        rules={[
          {
            pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
            message: 'Enter a valid email address!',
          },
        ]}
      >
        <InputContainer>
          <WizrText type='body2'>Email ID</WizrText>
          {/* <StyledWizrInput
      background={'#F2F4F9'}
      value={currentIntegration?.registered_emailid}
      onChange={(e: any) => 
        setCurrentIntegration({ ...currentIntegration, registered_emailid: e.target.value })
      }
    ></StyledWizrInput> */}
          <StyledWizrInput
            background={'#F2F4F9'}
            value={data?.registered_emailid || ''} // Ensure value is a string
            onChange={(value: any) => {
              setdata({
                ...data,
                registered_emailid: value,
              });
            }}
          />
        </InputContainer>
      </Form.Item>


      <InputContainer>
        <WizrText type='body2'>Ticket Status</WizrText>
        <StyledDropDown
          value={data?.ticket_status}
          options={TicketStatus}
          onChange={(value: any, label: any) => {
            setdata({ ...data, ticket_status: value })
          }}
        />
      </InputContainer>


      <InputContainer>
        <>
          <WizrFlexLayout
            justifyContent='flex-start'
            background='white'
            flexDirection="row"
            alignItems="center"
            style={{ gap: '16px', marginTop: '20px', marginBottom: '20px' }}
          >
            <WizrText type="sub2">Repeat</WizrText>
            <WizrToggleButton
              // disabled={hasAcces('enabledisable_cxsettings_features') === true ? false : true}
              isEnabled={isToggled}
              onChange={handleToggleChange}
            />

          </WizrFlexLayout>

          {isToggled && (
            <WizrFlexLayout flexDirection='row' background='white' justifyContent='space-between' style={{ marginBottom: '20px' }}>
              <Radio.Group onChange={onChangeRadio} value={radioValue}>
                <Radio value={1}>Daily</Radio>
                <Radio value={2}>Weekly</Radio>
                <Radio value={3}>Monthly</Radio>
                <Radio value={4}>Hourly</Radio>
              </Radio.Group>
            </WizrFlexLayout>
          )}

          {isToggled && radioValue === 4 && (
            <WizrFlexLayout background='white' style={{ gap: '20px' }}>
              <WizrFlexLayout flexDirection='row' background='white' style={{ gap: '20px' }}>
                <InputContainer>
                  <WizrText type='body2'>Import Start Date</WizrText>
                  <StyledDatePicker
                    onChange={onChangeStartDate}
                    showTime={{ defaultValue: dayjs(defaultTime, 'HH:mm:ss') }}
                    format="YYYY-MM-DD HH:mm:ss"
                    value={data?.start_date ? dayjs(data?.start_date) : null}
                  />
                </InputContainer>
                <InputContainer>
                  <WizrText type='body2'>Import End Date</WizrText>
                  <StyledDatePicker
                    onChange={onChangeEndDate}
                    disabledDate={disabledDate}
                    showTime={{ defaultValue: dayjs(defaultTime, 'HH:mm:ss') }}
                    format="YYYY-MM-DD HH:mm:ss"
                    value={data?.end_date ? dayjs(data?.end_date) : null}
                  />
                </InputContainer>
              </WizrFlexLayout>

              <InputContainer>
                <WizrText type='body2'>Hourly Interval</WizrText>
                <StyledDropDown
                  options={hourlyIntervalOptions}
                  onChange={(value: any) => setdata({ ...data, hourly_interval: value })}
                  value={data?.hourly_interval}
                />
              </InputContainer>

              <InputContainer>
                <WizrText type='body2'>Select Time</WizrText>
                <WizrTimePicker
                  value={data?.execution_time ? dayjs(data.execution_time, 'HH:mm:ss') : timeValue || undefined}
                  onChange={handleTimeChange}
                  format="HH:mm:ss"
                />
              </InputContainer>
            </WizrFlexLayout>
          )}

          {isToggled && radioValue === 1 && (
            <WizrFlexLayout background='white' style={{ gap: '20px' }}>

              <WizrFlexLayout flexDirection='row' background='white' style={{ gap: '20px' }}>
                <InputContainer>
                  <WizrText type='body2'>Import Start Date</WizrText>
                  <StyledDatePicker onChange={onChangeStartDate}
                    showTime={{ defaultValue: dayjs(defaultTime, 'HH:mm:ss') }}
                    format="YYYY-MM-DD HH:mm:ss"
                    value={data?.start_date ? dayjs(data?.start_date) : null} />
                </InputContainer>
                <InputContainer>
                  <WizrText type='body2'>Import End Date</WizrText>
                  <StyledDatePicker onChange={onChangeEndDate} disabledDate={disabledDate}
                    showTime={{ defaultValue: dayjs(defaultTime, 'HH:mm:ss') }}
                    format="YYYY-MM-DD HH:mm:ss"
                    value={data?.end_date ? dayjs(data?.end_date) : null} />
                </InputContainer>
              </WizrFlexLayout>

              {/* <WizrFlexLayout flexDirection='row' background='white' style={{ gap: '20px' }}>
            <InputContainer>
              <WizrText type='body2'>Time</WizrText>
              <StyledWizrInput background={'#F2F4F9'} onChange={()=>{}} />
            </InputContainer>
            </WizrFlexLayout> */}

              <WizrFlexLayout flexDirection='row' background='white' style={{ gap: '20px' }}>
                <InputContainer>
                  <WizrText type="body2">Select Time</WizrText>
                  <WizrTimePicker
                    value={data?.execution_time ? dayjs(data.execution_time, 'HH:mm:ss') : timeValue || undefined}
                    onChange={handleTimeChange}
                    format="HH:mm:ss"
                  />
                </InputContainer>
              </WizrFlexLayout>



            </WizrFlexLayout>
          )}

          {isToggled && radioValue === 2 && (
            <WizrFlexLayout background='white' style={{ gap: '20px' }}>

              <WizrFlexLayout flexDirection='row' background='white' style={{ gap: '20px' }}>
                <InputContainer>
                  <WizrText type='body2'>Import Start Date</WizrText>
                  <StyledDatePicker onChange={onChangeStartDate}
                    showTime={{ defaultValue: dayjs(defaultTime, 'HH:mm:ss') }}
                    format="YYYY-MM-DD HH:mm:ss"
                    value={data?.start_date ? dayjs(data?.start_date) : null} />
                </InputContainer>
                <InputContainer>
                  <WizrText type='body2'>Import End Date</WizrText>
                  <StyledDatePicker onChange={onChangeEndDate} disabledDate={disabledDate}
                    showTime={{ defaultValue: dayjs(defaultTime, 'HH:mm:ss') }}
                    format="YYYY-MM-DD HH:mm:ss"
                    value={data?.end_date ? dayjs(data?.end_date) : null} />
                </InputContainer>
              </WizrFlexLayout>

              <WizrFlexLayout flexDirection='row' background='white' style={{ gap: '20px' }}>
                <InputContainer>
                  <WizrText type='body2'>Select Day</WizrText>
                  <StyledDropDown options={daysOfWeek} onChange={handleDaySelection} value={data?.execution_day} />
                </InputContainer>
              </WizrFlexLayout>

              {/* <WizrFlexLayout flexDirection='row' background='white' style={{ gap: '20px' }}>
                <InputContainer>
                  <WizrText type='body2'>Time</WizrText>
                  <StyledWizrInput background={'#F2F4F9'} onChange={()=>{}} />
                </InputContainer>
                </WizrFlexLayout>               */}

              <WizrFlexLayout flexDirection='row' background='white' style={{ gap: '20px' }}>
                <InputContainer>
                  <WizrText type="body2">Select Time</WizrText>
                  <WizrTimePicker value={timeValue || undefined} onChange={handleTimeChange} format="HH:mm:ss"
                  />
                </InputContainer>
              </WizrFlexLayout>
            </WizrFlexLayout>
          )}

          {isToggled && radioValue === 3 && (
            <WizrFlexLayout background='white' style={{ gap: '20px' }}>
              <WizrFlexLayout flexDirection='row' background='white' style={{ gap: '20px' }}>
                <InputContainer>
                  <WizrText type='body2'>Import Start Date</WizrText>
                  <StyledDatePicker onChange={onChangeStartDate}
                    showTime={{ defaultValue: dayjs(defaultTime, 'HH:mm:ss') }}
                    format="YYYY-MM-DD HH:mm:ss"
                    value={data?.start_date ? dayjs(data?.start_date) : null} />
                </InputContainer>
                <InputContainer>
                  <WizrText type='body2'>Import End Date</WizrText>
                  <StyledDatePicker onChange={onChangeEndDate} disabledDate={disabledDate}
                    showTime={{ defaultValue: dayjs(defaultTime, 'HH:mm:ss') }}
                    format="YYYY-MM-DD HH:mm:ss"
                    value={data?.end_date ? dayjs(data?.end_date) : null} />
                </InputContainer>
              </WizrFlexLayout>
              <WizrFlexLayout flexDirection='row' background='white' style={{ gap: '20px' }}>
                <InputContainer>
                  <WizrText type='body2'>Select Date</WizrText>
                  <StyledDropDown options={dateOptions} onChange={handleDateSelection} value={data?.execution_date} />
                </InputContainer>
              </WizrFlexLayout>

              {/* <WizrFlexLayout flexDirection='row' background='white' style={{ gap: '20px' }}>
                <InputContainer>
                  <WizrText type='body2'>Time</WizrText>
                  <StyledWizrInput background={'#F2F4F9'} onChange={()=>{}} />
                </InputContainer>
                </WizrFlexLayout>    */}

              <WizrFlexLayout flexDirection='row' background='white' style={{ gap: '20px' }}>
                <InputContainer>
                  <WizrText type="body2">Select Time</WizrText>
                  <WizrTimePicker value={timeValue || undefined} onChange={handleTimeChange} format="HH:mm:ss" />
                </InputContainer>
              </WizrFlexLayout>

            </WizrFlexLayout>
          )}
        </>
      </InputContainer>


      <WizrFlexLayout
        justifyContent='flex-end'
        flexDirection='row'
        background='white'
        style={{ padding: '10px 0px 10px 10px', gap: '20px' }}
      >
        <StyledButton type='default' text='Cancel' onClick={onCancel}></StyledButton>
        <StyledButton
          // htmlType='submit'
          type='primary'
          text={<WizrText type='button'>{isEdit ? 'Save' : 'Schedule'}</WizrText>}
          onClick={() => { onSchedule() }}
        ></StyledButton>
      </WizrFlexLayout>


    </WizrFlexLayout>

  );
}
export default AddSchedule;